// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import humanizeDuration from 'humanize-duration';
import MetadataField from './metadata-field';

export default class DurationField extends MetadataField {
  static propTypes = {
    ...MetadataField.propTypes,
  };

  renderLabelContent() {
    return (
      <span>
        <strong className={MetadataField.styles.strong}>Duration</strong>
      </span>
    );
  }

  renderValueContent() {
    return <span>{this.valueString}</span>;
  }

  get valueString() {
    return (
      <div>
        {(this.props.feature.editedDuration !== this.props.feature.createdDuration) && this.renderDuration(this.props.feature.editedDuration, 'Total Time')}
        {(this.props.feature.editedDuration !== this.props.feature.updatedDuration) && this.renderDuration(this.props.feature.updatedDuration, 'Most Recent Update')}
        {this.renderDuration(this.props.feature.createdDuration, 'First Creation')}
      </div>
    );
  }

  renderDuration(duration, label) {
    if (duration == null) {
      return null;
    }

    const { styles } = DurationField;

    return (
      <div className={styles.duration}>
        {humanizeDuration(duration * 1000)}
        {' '}
        <span className={styles.label}>
          (
          {label}
          )
        </span>
      </div>
    );
  }
}

const styles = cssInJS({
  duration: {
  },

  label: {
    color: '#888',
    marginRight: 5,
  },
});

DurationField.styles = styles;
